import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class SubscriptionTypes {
  static list: IActionType = new ActionType('SUBSCRIPTION/LIST');
  static invoices: IActionType = new ActionType('SUBSCRIPTION/INVOICES');
  static postback: IActionType = new ActionType('SUBSCRIPTION/POSTBACK');
  static cancel: IActionType = new ActionType('SUBSCRIPTION/CANCEL');
  static reactivate: IActionType = new ActionType('SUBSCRIPTION/REACTIVATE');
  static cancelAgend: IActionType = new ActionType('SUBSCRIPTION/CANCEL_AGEND');
  static suspend: IActionType = new ActionType('SUBSCRIPTION/SUSPEND');
  static products: IActionType = new ActionType('SUBSCRIPTION/PRODUCTS');
  static status: IActionType = new ActionType('SUBSCRIPTION/STATUS');
  static charge: IActionType = new ActionType('SUBSCRIPTION/CHARGE');
  static addAffiliate: IActionType = new ActionType('SUBSCRIPTION/ADD_AFFILIATE');
  static changeChargeEmail: IActionType = new ActionType('SUBSCRIPTION/CHANGE_CHARGE_EMAIL');
  static setNewDueDate: IActionType = new ActionType('SUBSCRIPTION/SET_NEW_DUE_DATE');
  static changePayment: IActionType = new ActionType('SUBSCRIPTION/CHANGE_PAYMENT');
  static export: IActionType = new ActionType('SUBSCRIPTION/EXPORT');
  static bankslip: IActionType = new ActionType('SUBSCRIPTION/BANKSLIP');
  static changePaymentBankslip: IActionType = new ActionType('SUBSCRIPTION/CHANGE_PAYMENT_BANKSLIP');
  static getContractData: IActionType = new ActionType('SUBSCRIPTION/GET_DATA');
  static getNextToken: IActionType = new ActionType('SUBSCRIPTION/GET_NEXT_TOKEN');
  static saveNegotiateInvoices: IActionType = new ActionType('SUBSCRIPTION/SAVE_NEGOTIATE_INVOICE');
}

export default SubscriptionTypes;
